/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEventsAssignReviewerResponse
 */
export interface BulkEventsAssignReviewerResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkEventsAssignReviewerResponse
     */
    ok: number;
    /**
     * 
     * @type {number}
     * @memberof BulkEventsAssignReviewerResponse
     */
    failed: number;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof BulkEventsAssignReviewerResponse
     */
    failures: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkEventsAssignReviewerResponse
     */
    failuresTruncated: boolean;
}

/**
 * Check if a given object implements the BulkEventsAssignReviewerResponse interface.
 */
export function instanceOfBulkEventsAssignReviewerResponse(value: object): value is BulkEventsAssignReviewerResponse {
    if (!('ok' in value) || value['ok'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    if (!('failures' in value) || value['failures'] === undefined) return false;
    if ((!('failuresTruncated' in (value as Record<string, any>)) && !('failures_truncated' in (value as Record<string, any>))) || ((value as Record<string, any>)['failuresTruncated'] === undefined && (value as Record<string, any>)['failures_truncated'] === undefined)) return false;
    return true;
}

export function BulkEventsAssignReviewerResponseFromJSON(json: any): BulkEventsAssignReviewerResponse {
    return BulkEventsAssignReviewerResponseFromJSONTyped(json, false);
}

export function BulkEventsAssignReviewerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEventsAssignReviewerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ok': json['ok'],
        'failed': json['failed'],
        'failures': json['failures'],
        'failuresTruncated': json['failures_truncated'],
    };
}

export function BulkEventsAssignReviewerResponseToJSON(json: any): BulkEventsAssignReviewerResponse {
    return BulkEventsAssignReviewerResponseToJSONTyped(json, false);
}

export function BulkEventsAssignReviewerResponseToJSONTyped(value?: BulkEventsAssignReviewerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ok': value['ok'],
        'failed': value['failed'],
        'failures': value['failures'],
        'failures_truncated': value['failuresTruncated'],
    };
}

